import type { BaseClient } from '../../http/BaseClient.js';
import { sandboxAdapter } from '../../adapters/sandboxAdapter.js';
import type {
  CreateSandboxRequest,
  ListSandboxesQuery,
  Sandbox,
  UpdateSandboxRequest,
} from './types.js';

interface SimpleResponse {
  success: boolean;
  message?: string;
}

export class SandboxesClient {
  constructor(private readonly http: BaseClient) {}

  async list(query: ListSandboxesQuery = {}): Promise<Sandbox[]> {
    const res = await this.http.get<unknown>('/sandbox', {
      query: { projectId: query.projectId },
    });
    return sandboxAdapter.fromListResponse(res);
  }

  async get(sandboxId: string): Promise<Sandbox> {
    const res = await this.http.get<unknown>(`/sandbox/${sandboxId}`);
    return sandboxAdapter.fromGetResponse(res);
  }

  async create(body: CreateSandboxRequest): Promise<Sandbox> {
    const res = await this.http.post<unknown>('/sandbox', {
      body: {
        name: body.name,
        projectId: body.projectId,
        storageType: body.storageType ?? 'S3',
        mode: body.mode ?? 'NORMAL',
      },
    });
    return sandboxAdapter.fromGetResponse(res);
  }

  async update(sandboxId: string, body: UpdateSandboxRequest): Promise<Sandbox> {
    const res = await this.http.put<unknown>(`/sandbox/${sandboxId}`, { body });
    return sandboxAdapter.fromGetResponse(res);
  }

  delete(sandboxId: string): Promise<SimpleResponse> {
    return this.http.delete<SimpleResponse>(`/sandbox/${sandboxId}`);
  }
}
